import type { ComponentSchema } from '../../../schema-types'
import { schema as emiCalculatorSchema } from './emi-calculator.schema'
import { schema as offersListSchema } from './offers-list.schema'
import { schema as pcBuilderSchema } from './pc-builder.schema'
import { schema as powerCalculatorSchema } from './power-calculator.schema'

/** Offers page, shopping tools (EMI and power supply calculators) and the PC Builder. */
export const toolsSchemas: Record<string, ComponentSchema> = {
  'offers-list': offersListSchema,
  'emi-calculator': emiCalculatorSchema,
  'power-calculator': powerCalculatorSchema,
  'pc-builder': pcBuilderSchema,
}
